<template>
  <div>
    <!-- 上传 -->
    <el-upload class="avatar-uploader"
               :name="file_name"
               :action="upLoadAPI"
               :show-file-list="false"
               :with-credentials="true"
               :on-success="handleAvatarSuccess"
               :before-upload="beforeAvatarUpload"
               :auto-upload="autoUpload"
               :accept="accept">
      <img v-if="imageUrl"
           :src="imageUrl"
           :style="imageSize"
           class="avatar" />
      <i v-else
         :style="imageSize"
         class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>
    <!-- 剪切 -->
    <!-- vueCropper 剪裁图片实现-->
    <el-dialog @close="closeDialog"
               :title="dialogName"
               :visible.sync="dialogVisible"
               append-to-body>
      <div class="cropper-content">
        <div class="cropper"
             style="text-align: center">
          <vueCropper ref="cropper"
                      :img="option.img"
                      :outputSize="option.size"
                      :outputType="option.outputType"
                      :info="true"
                      :full="option.full"
                      :canMove="option.canMove"
                      :canMoveBox="option.canMoveBox"
                      :original="option.original"
                      :autoCrop="option.autoCrop"
                      :fixed="option.fixed"
                      :fixedNumber="option.fixedNumber"
                      :centerBox="option.centerBox"
                      :infoTrue="option.infoTrue"
                      :fixedBox="option.fixedBox"></vueCropper>
        </div>
      </div>
      <div slot="footer"
           class="dialog-footer">
        <el-button size="mini"
                   @click="dialogVisible = false">取 消</el-button>
        <el-button size="mini"
                   type="primary"
                   @click="finishCopper"
                   :loading="loading">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'up-load',
  data() {
    return {
      upLoadAPI: '',
      file_name: this.fileName,
      imageSize: {
        width: this.imageWidth,
        height: this.imageHeight,
        lineHeight: this.imageHeight,
      },
      imageUrl: this.default_image, // 上传图片框 处 的 图片链接， 通过v-if判断，如果有则显示图片，如果没有则不显示图片
      image_url: '', // 返回的图片链接
      accept: this.accept_format,
      // 剪裁框
      dialogVisible: false,
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: this.cropWidth, // 默认生成截图框宽度
        autoCropHeight: this.cropHeight, // 默认生成截图框高度
        //
        fixedBox: this.fixCropBox, // 固定截图框大小 不允许改变
        fixed: this.fixed, // 是否开启截图框宽高固定比例
        fixedNumber: this.fixedRatio, // 截图框的宽高比例
        //
        full: false, // 是否输出原图比例的截图：截取原图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: false, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      loading: false, // 防止重复提交
    }
  },
  props: {
    // 接口对应的 文件 key 名称
    fileName: {
      type: String,
      default: 'image',
    },
    // 要求上传图像的尺寸
    imageWidth: {
      type: String,
      default: '178px',
    },
    imageHeight: {
      type: String,
      default: '178px',
    },
    // 上传链接
    upLoadApiName: {
      type: String,
      default: '/add_image',
    },
    // 上传文件前缀
    keyName: {
      type: String,
      default: 'default_name',
    },
    // 是否自动上传
    autoUpload: {
      type: Boolean,
      // default: false,
      default: true,
    },
    // 上传的图片的 大小
    limitSize: {
      type: Number,
      default: 2,
    },
    // 接受的格式
    accept_format: {
      type: String,
      default: '.jpg, .jpeg, .png, .gif',
    },
    //  默认填充图片
    default_image: {
      type: String,
      default: '',
    },
    // -----------------截图----------------
    // 截图框名称：
    dialogName: {
      type: String,
      default: '图片剪裁',
    },
    // 是否 按固定比例 截图
    fixed: {
      type: Boolean,
      default: true,
    },
    fixedRatio: {
      type: Array,
      default: () => {
        return [1, 1]
      },
    },
    // 截图框 宽 高
    cropWidth: {
      type: Number,
      default: 980,
    },
    cropHeight: {
      type: Number,
      default: 540,
    },
    // 裁切框 是否可以调整
    fixCropBox: {
      tpye: Boolean,
      default: true,
    },
  },
  watch: {
    default_image(newValue) {
      this.imageUrl = newValue
    },
  },
  mounted() {
    // 定义接口和上传的文件名
    this.upLoadAPI = this.$ip + this.upLoadApiName + '?key_name=' + this.keyName
    // console.log(this.upLoadAPI);
  },
  methods: {
    // 确认剪切 button事件
    finishCopper() {
      let formData = new FormData()
      this.$refs.cropper.getCropBlob((data) => {
        let newImageName = this.keyName + '_croper_' + this.fileinfo.uid

        formData.append(this.fileName, data)
        // console.log(formData.get("key")); 用get取值
        this.$http
          .post(`/add_image_https?key_name=${newImageName}`, formData)
          .then((res) => {
            if (res.data.errno == '4101' || res.data.errno == '4602') {
              this.$notify({
                title: '警告',
                message: res.errmsg,
                type: 'warning',
              })
              return
            } else if (res.data.errno == '0') {
              this.imageUrl = res.data.image_url
              // 发送事件给父组件
              this.$emit('getCroperImageURl', this.imageUrl)
              // 关闭对话框
              this.dialogVisible = false
              // 关闭菊花
              this.loading = false
            }
          })
        this.loading = true
      })
    },
    // 上传前对数据进行检查
    beforeAvatarUpload(file) {
      // 检查 长宽 是否符合要求
      this.imageChecked(file)
      // 检查图片格式
      const isFORMAT =
        file.type === 'image/jpeg' ||
        file.type === 'image/png' ||
        file.type === 'image/gif'
      // 检查图片大小
      const isLt2M = file.size / 1024 / 1024 < this.limitSize
      if (!isFORMAT) {
        this.$message.error(`上传头像图片只能是 ${this.accept_format} 格式!`)
      }
      if (!isLt2M) {
        this.$message.error(`上传头像图片大小不能超过 ${this.limitSize}MB!`)
      }
      // 返回布尔
      return isFORMAT && isLt2M
    },

    // 【上传成功】时的钩子函数，将返回值添加到页面中
    handleAvatarSuccess(res, file) {
      if (res.errno == '4101' || res.errno == '4602') {
        this.$notify({
          title: '警告',
          message: res.errmsg,
          type: 'warning',
        })
        return
      } else if (res.errno == '0') {
        // 上传成功
        this.fileinfo = file
        this.image_url = res.data.image_url
        // 让图片可以展示在前端
        // this.imageUrl = URL.createObjectURL(file.raw);
        this.$emit('getImageURl', this.image_url)

        // 上传成功后将图片地址赋值给裁剪框显示图片
        this.$nextTick(() => {
          this.option.img = URL.createObjectURL(file.raw)
          this.dialogVisible = true
        })
      }
    },
    // 检查图片长宽 是否符合要求的方法
    imageChecked(file) {
      let _this = this
      return new Promise(function (resolve, reject) {
        // 检查文件的长款 是否符合 imageWidth 和 imageHeight
        // 创建一个 读取文件 webAPI的对象
        // const isSize = new FileReader();
        // FileReader() 加载完成时 执行
        // isSize.onload = (event) => {
        // 创建一个图片对象
        let image = new Image()
        // 获取到图片宽高信息：image.onload
        image.onload = () => {
          // 设定长宽
          let width = image.width
          let height = image.height
          // 进行图片大小的判断
          if (width !== _this.imageWidth || height !== _this.imageHeight) {
            _this.$message.error(
              `图片尺寸需要是 ${_this.imageWidth} x${_this.imageHeight} `
            )
            reject()
          }
          // if (height > 695 || height < 685) {
          //   _this.$alert("图片尺寸必须在685~695之间！", "提示", {
          //     confirmButtonText: "确定",
          //   });
          //   reject();
          // }
          resolve()
        }
        // image.src = event.target.result;
        // };

        // isSize.readAsDataURL(file);
        // FileReader对象的readAsDataURL方法可以将读取到的文件编码成Data URL
        // Data URL
      })
    },
    closeDialog() {
      this.loading = false
    },
  },
}
</script>

<style>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  text-align: center;
}
.avatar {
  /* width: 178px;
  height: 178px; */
  display: block;
}
/* 设置截图容器的高度 */

.cropper {
  width: auto;
  height: 300px;
}
</style>